import React from 'react';

import { Button, Divider } from 'antd';

import { FormattedMessage } from 'react-intl';

const SettingList = (props) => {
  const { openModalForCreateNewList, modalType, deleteItem, LESSON, EDIT } =
    props;
  return (
    <>
      <div className="setting_list">
        <Button
          type="primary"
          size="small"
          onClick={() => openModalForCreateNewList(LESSON)}
        >
          <span>
            <FormattedMessage id="Add lesson" defaultMessage="Add lesson" />
          </span>
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => openModalForCreateNewList(modalType, EDIT)}
        >
          <span>
            <FormattedMessage id="Change title" defaultMessage="Change title" />
          </span>
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => {
            deleteItem(modalType);
          }}
        >
          <span>
            <FormattedMessage id="Delete" defaultMessage="Delete" />
          </span>
        </Button>
      </div>
      <Divider orientation="left/right" className="divider_academy" />
    </>
  );
};

export default SettingList;
